module.exports = __webpack_public_path__ + "img/thumb-2.7edefcc4.png";